import {css} from "@emotion/css";
import StatisticsCart from "../../component/statisticsCart/StatisticsCart";
import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";

export default function UsersStatistics() {
    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn className={css`gap: 2rem`}>
                <RaikoBreadcrumb
                    breadCrumbItems={[raikoBreadCrumbItemGenerator("آمار کاربران", "")]}
                />
                <div className={css`
                  display: flex;
                  justify-content: center;
                  flex-wrap: wrap;
                  row-gap: 2rem;
                  column-gap: 1rem;
                `}>
                    <StatisticsCart title={"کاربران جدید امروز"} end={0} duration={2000}/>
                    <StatisticsCart title={"کاربران جدید هفته"} end={1} duration={2000}/>
                    <StatisticsCart title={"کاربران جدید ماه"} end={23} duration={2000}/>
                    <StatisticsCart title={"کل کاربران"} end={21214} duration={2000}/>
                </div>
                {/*<RaikoBaseCardContainer>*/}
                {/*    <RaikoErrorSection*/}
                {/*        image={underConstruction}*/}
                {/*        title={"در حـال توسعـه"}*/}
                {/*    />*/}
                {/*</RaikoBaseCardContainer>*/}
            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}